'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _env = require('../env');

/**
 * env().fedops.apps wrapper (for tests mainly)
 */
function getAppData(appName) {
  return (0, _env.env)().fedops.apps[appName];
}

exports.default = {
  init: function init(appName) {
    (0, _env.env)().fedops.apps[appName] = (0, _env.env)().fedops.apps[appName] || {};
  },
  getStartLoadTime: function getStartLoadTime(appName) {
    var appData = getAppData(appName);
    if (!appData) {
      return null;
    }
    return appData.startLoadTime;
  },
  setStartLoadTime: function setStartLoadTime(appName, startLoadTime) {
    return getAppData(appName).startLoadTime = startLoadTime;
  }
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/fedops-logger/dist/src/app-data/app-data.js
// module id = 77
// module chunks = 0